import { render } from "./schoolDashboard.vue?vue&type=template&id=04a07281&scoped=true"
import script from "./schoolDashboard.vue?vue&type=script&lang=js"
export * from "./schoolDashboard.vue?vue&type=script&lang=js"

import "./schoolDashboard.vue?vue&type=style&index=0&id=04a07281&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a07281"]])

export default __exports__